import { render, staticRenderFns } from "./PdpPopup.vue?vue&type=template&id=a6e3083a&scoped=true"
import script from "./PdpPopup.vue?vue&type=script&lang=js"
export * from "./PdpPopup.vue?vue&type=script&lang=js"
import style0 from "./PdpPopup.vue?vue&type=style&index=0&id=a6e3083a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e3083a",
  null
  
)

export default component.exports